import WorkingSchedule from '@/models/childcare-provider/workingSchedule';
import BookedOrder from "@/models/booking/bookedOrder";
import BookingStatus from "@/models/booking/bookingStatus";
import BookingService from '@/services/bookingService';
import ProviderBackgroundGalleryModel from "@/models/childcare-provider/providerBackgroundGalleryModel";
import ProviderBackgroundGalleryIsDispatchedModel from "@/models/childcare-provider/providerBackgroundGalleryIsDispatchedModel";

export const booking = {
  namespaced: true,
  state: {
    namespaced: true,
    childcareProviders: [],
    childIdForBooking: '',
    providerIdForBooking: '',
    bookingStatus: new BookingStatus(),
    providerBackgroundGalleryIsDispatched: new Array<ProviderBackgroundGalleryIsDispatchedModel>(),
    providerBackgroundGallery: new Array<ProviderBackgroundGalleryModel>(),

    //Booking time page
    bookedDays: new Array<BookedOrder>(),
    workingSchedule: [],

    filterData: {
      providerType: [
        {
          id: 11,
          name: "Licenced",
          img: require("@/assets/images/booking/filter/cowgirl_h100.png"),
          checked: true,
          disabled: false
        },
        {
          id: 12,
          name: "Unlicenced",
          img: require("@/assets/images/booking/filter/bear_h100.png"),
          checked: true,
          disabled: false
        },
        {
          id: 13,
          name: "Drop-in",
          img: require("@/assets/images/booking/filter/rabbit_h100.png"),
          checked: false,
          disabled: true
        }
      ] as Array<any>,
      ageGroupsType: [
        {
          id: 14,
          name: "Infant",
          displayName: "Infant",
          ageGroupRange: "0 - 18 mos",
          img: require("@/assets/images/booking/filter/Filter_Infant.svg"),
          checked: false,
          disabled: false
        },
        {
          id: 15,
          name: "Toddler",
          displayName: "Toddler",
          ageGroupRange: "1.5 - 2.5 yrs",
          img: require("@/assets/images/booking/filter/Filter_Toddler.svg"),
          checked: false,
          disabled: false
        },
        {
          id: 16,
          name: "Preschool",
          displayName: "Preschool",
          ageGroupRange: "2.5 - 6 yrs",
          img: require("@/assets/images/booking/filter/Filter_PreSchool.svg"),
          checked: false,
          disabled: true
        },
        {
          id: 17,
          name: "Kindergarten",
          displayName: "Kindergarten",
          ageGroupRange: "3 yrs 8 mos - 7 yrs",
          img: require("@/assets/images/booking/filter/Filter_Kindergarten.svg"),
          checked: false,
          disabled: true
        },
        {
          id: 18,
          name: "PrimaryJrSchool",
          displayName: "Primary Jr. School",
          ageGroupRange: "5 yrs 8 mos - 13 yrs",
          img: require("@/assets/images/booking/filter/Filter_PrimaryJrSchool.svg"),
          checked: false,
          disabled: true
        },
        {
          id: 19,
          name: "JrSchool",
          displayName: "Jr. School",
          ageGroupRange: "9 - 13 yrs",
          img: require("@/assets/images/booking/filter/Filter_JrSchool.svg"),
          checked: false,
          disabled: true
        }
      ] as Array<any>,  
      careType: [
        {
          id: 21,
          name: "Weekdays",
          timeFrame: "6am - 6pm",
          img: require("@/assets/images/booking/filter/days_h100.png"),
          checked: false
        },
        {
          id: 22,
          name: "Evening",
          timeFrame: "6pm - 12am",
          img: require("@/assets/images/booking/filter/evening_h100.png"),
          checked: false
        },
        {
          id: 25,
          name: "Overnight",
          timeFrame: "6pm - 6am",
          img: require("@/assets/images/booking/filter/night_h100.png"),
          checked: false
        },
        {},
        {
          id: 23,
          name: "Sat & Sun",
          timeFrame: "6am - 6pm",
          img: require("@/assets/images/booking/filter/weekend_h100.png"),
          checked: false
        },
        {},
        {
          id: 24,
          name: "Before or After School",
          timeFrame: "",
          img: require("@/assets/images/booking/filter/school_h100.png"),
          imgDisabled: require("@/assets/images/booking/filter/school_grey_h100.png"),
          checked: false,
          schoolFilter: true,
        },
        {
          id: 26,
          name: "Drop off or pick up",
          timeFrame: "",
          img: require("@/assets/images/booking/filter/car_w100.png"),
          imgDisabled: require("@/assets/images/booking/filter/car_grey_w100.png"),
          checked: false,
          dropOffPickUp: true,
        },
        {
          id: 27,
          name: "Subsidy",
          img: require("@/assets/images/booking/filter/subsidy_h100.png"),
          checked: false
        },
        {
          id: 28,
          name: "Special needs",
          img: require("@/assets/images/booking/filter/special-needs.png"),
          checked: false
        }
      ] as Array<any>
    },
    allProviders: [],
    providers: [],
    disableSchoolFilter: true,
    providersToShow: [],
    childId: '',
    filteredProvidersArr: []
  },
  getters: {
    getChildcareProviders: (state: any) => {
      return state.childcareProviders;
    },
    getBookedDays(state: any) {
      return state.bookedDays;
    },
    getBookedDaysByProviderId: (state: any) => (providerId: string) => {
      return state.bookedDays.filter((x: any) => x.childcareProviderId == providerId);
    },
    getProviderById: (state: any) => (providerId: string) => {
      const provider = state.childcareProviders.find((provider: any) => provider.id == providerId);

      return provider;
    },    
    getProviderId(state: any) {
      return state.providerIdForBooking;
    },
    getChildId(state: any) {
      return state.childIdForBooking;
    },
    getProviderScheduleById: (state: any) => (providerId: string) => {
      const providerWorkingSchedule = state.workingSchedule.filter((x: WorkingSchedule) => x.childcareProviderId == providerId);
      
      return providerWorkingSchedule;
    },
    getProgramStatementByProviderId: (state: any) => (providerId: string) => {
      const provider = state.childcareProviders.find((provider: any) => provider.id == providerId);

      return provider.programStatement;
    },
    getBookingStatus: (state: any) => {
      return state.bookingStatus;
    },
    getProviderBackgroundGalleryIsDispatched: (state: any) => (userId: string) => {
      const providerBackgroundGalleryIsDispatched: ProviderBackgroundGalleryIsDispatchedModel = state
        .providerBackgroundGalleryIsDispatched
        .find((providerBackgroundGalleryIsDispatched: ProviderBackgroundGalleryIsDispatchedModel) => providerBackgroundGalleryIsDispatched.userId == userId);

      const isDispatched: boolean = providerBackgroundGalleryIsDispatched ? providerBackgroundGalleryIsDispatched.isDispatched : false;

      return(isDispatched);
    },
    getProviderBackgroundGallery: (state: any) => (userId: string) => {
      let providerBackgroundGallery: ProviderBackgroundGalleryModel = state
        .providerBackgroundGallery
        .find((providerBackgroundGallery: ProviderBackgroundGalleryModel) => providerBackgroundGallery.userId == userId);

      providerBackgroundGallery = providerBackgroundGallery ? providerBackgroundGallery : new ProviderBackgroundGalleryModel(userId);

      return(providerBackgroundGallery);
    },
    getChildcareLocationByProviderId: (state: any) => (providerId: string) => {
      const provider = state.childcareProviders.find((provider: any) => provider.id == providerId);

      return provider.childcareLocation;
    },
  },
  actions: {
    clear: (context: any) => {
      context.commit('clear');
    },    
    getProviders({ commit }: any) {
      return BookingService.getAllProviders().then(success => {
        commit('setProviders', success.data);

        return Promise.resolve(success.data);
      }, error => {
        return Promise.reject(error);
      })
    },
    getProviderFilters() {
      return BookingService.getProviderFilters().then(success => {
        return Promise.resolve(success.data);
      }, error => {
        return Promise.reject(error);
      })
    },
    getBadgesIsActivated({ commit, dispatch }: any, providerId: string) {
      return BookingService.getBadgesIsActivated(providerId).then((success: any) => {
        return Promise.resolve(success.data);
      }, error => {
        return Promise.reject(error);
      })
    },
    getFamilyAmenitiesById({ commit, dispatch }: any, providerId: string) {
      return BookingService.getFamilyAmenitiesById(providerId).then((success: any) => {
        return Promise.resolve(success.data);
      }, error => {
        return Promise.reject(error);
      })
    },
    getPoliciesAndProceduresById({ commit, dispatch }: any, providerId: string) {
      return BookingService.getPoliciesAndProceduresById(providerId).then((success: any) => {
        return Promise.resolve(success.data);
      }, error => {
        return Promise.reject(error);
      })
    },
    getHoursOfBusinessById({ commit, dispatch }: any, providerId: string) {
      return BookingService.getHoursOfBusinessById(providerId).then((success: any) => {
        commit('setWorkingSchedule', success.data);
        return Promise.resolve(success.data);
      }, error => {
        return Promise.reject(error);
      })
    },
    getAvailabilitySettingsByProviderId({ commit, dispatch }: any, providerId: string) {
      return BookingService.getAvailabilitySettingsByProviderId(providerId).then((success: any) => {
        return Promise.resolve(success.data);
      }, error => {
        return Promise.reject(error);
      })
    },
    getDaycareOrders({ commit, dispatch }: any, providerId: string) {
      return BookingService.getDaycareOrders(providerId).then((success: any) => {
        let availableDays = success.data.filter((day: BookedOrder) => day.isBooked == false)
        commit('setBookedDays', availableDays);

        return Promise.resolve(availableDays);
      }, error => {
        return Promise.reject(error);
      })
    },
    getProviderCurrentOrders({ commit, dispatch }: any, providerId: string) {
      return BookingService.getProviderCurrentOrders(providerId).then((success: any) => {
        return Promise.resolve(success.data);
      }, error => {
        return Promise.reject(error);
      })
    },
    saveDaycareOrder({ commit }: any, data: any) {
      return BookingService.saveDaycareOrder(data).then(success => {
        data.id = success.data;
        commit('addBookedDay', data);
        return Promise.resolve(success);
      }, error => {
        return Promise.reject(error);
      })
    },
    cancelOrder({ commit, state }: any, data: BookedOrder) {
      return BookingService.cancelOrder(data).then(success => {
        commit('updateBookedDay', data);
        return Promise.resolve(success);
      }, error => {
        return Promise.reject(error);
      })
    },
    deleteDaycareOrder({ commit }: any, payload: { id: string }) {
      return BookingService.deleteDaycareOrder(payload.id).then((success: any) => {
        commit('removeBookedDay', payload.id);
        return Promise.resolve(success);
      }, error => {
        return Promise.reject(error);
      })
    },
    // Отправка подтвер
    bookDaycareOrder({ commit }: any, data: any) {
      return BookingService.bookDaycareOrder(data).then(success => {
        // commit('addBookedDay', data);
        return Promise.resolve(success);
      }, error => {
        return Promise.reject(error);
      })
    },
    childCareApproveOrder({ commit }: any, data: any) {
      return BookingService.childCareApproveOrder(data).then(success => {
        return Promise.resolve(success);
      }, error => {
        return Promise.reject(error);
      })
    },
    setPickUpTimeStamp({ commit }: any, orderId: string) {
      return BookingService.setPickUpTimeStamp(orderId).then(success => {
        return Promise.resolve(success);
      }, error => {
        return Promise.reject(error);
      })
    },
    setCheckInTimeStamp({ commit }: any, orderId: string) {
      return BookingService.setCheckInTimeStamp(orderId).then(success => {
        return Promise.resolve(success);
      }, error => {
        return Promise.reject(error);
      })
    },
    setNoShowChild({ commit }: any, orderId: string) {
      return BookingService.setNoShowChild(orderId).then(success => {
        return Promise.resolve(success);
      }, error => {
        return Promise.reject(error);
      })
    },
    childCareApproveAllOrders({ commit }: any, data: any) {
      return BookingService.childCareApproveAllOrders(data).then(success => {
        return Promise.resolve(success);
      }, error => {
        return Promise.reject(error);
      })
    },
    childCareRefuseOrder({ commit }: any, data: any) {
      return BookingService.childCareRefuseOrder(data).then(success => {
        return Promise.resolve(success);
      }, error => {
        return Promise.reject(error);
      })
    },
    childCareRefuseAllOrders({ commit }: any, data: any) {
      return BookingService.childCareRefuseAllOrders(data).then(success => {
        return Promise.resolve(success);
      }, error => {
        return Promise.reject(error);
      })
    },
    childCareSetOrderHideCard({ commit }: any, orderId: string) {
      return BookingService.childCareSetOrderHideCard(orderId).then(success => {
        return Promise.resolve(success);
      }, error => {
        return Promise.reject(error);
      })
    },
    childCareClearOrdersHideCardForProvider({ commit }: any) {
      return BookingService.childCareClearOrdersHideCardForProvider().then(success => {
        return Promise.resolve(success);
      }, error => {
        return Promise.reject(error);
      })
    },
    parentSetOrderHideCard({ commit }: any, orderId: string) {
      return BookingService.parentSetOrderHideCard(orderId).then(success => {
        return Promise.resolve(success);
      }, error => {
        return Promise.reject(error);
      })
    },
    parentClearOrdersHideCardForParent({ commit }: any) {
      return BookingService.parentClearOrdersHideCardForParent().then(success => {
        return Promise.resolve(success);
      }, error => {
        return Promise.reject(error);
      })
    },
    parentRefuseAllOrders({ commit }: any, data: any) {
      return BookingService.parentRefuseAllOrders(data).then(success => {
        return Promise.resolve(success);
      }, error => {
        return Promise.reject(error);
      })
    },
    getParentOrdersHistory({ commit }: any) {
      return BookingService.getParentOrdersHistory().then((success: any) => {
        return Promise.resolve(success.data);
      }, (error: any) => {
        return Promise.reject(error);
      })
    },
    getUserProfileById({ commit }: any, id: string) {
      return BookingService.getUserProfileById(id).then(success => {
        return Promise.resolve(success);
      }, error => {
        return Promise.reject(error);
      })
    },
    saveFavoritesLiked({ commit }: any, data: any) {            
      return BookingService.saveFavoritesLiked(data).then(success => {         
         return Promise.resolve(success);
       }, error => {
         return Promise.reject(error);
       })
    },
    getProviderOrdersHistory({ commit }: any) {
      return BookingService.getProviderOrdersHistory().then((success: any) => {
        return Promise.resolve(success.data);
      }, (error: any) => {
        return Promise.reject(error);
      })
    },
    getHolidaysForRestNextYear({ commit, dispatch }: any, data: any) {
      return BookingService.getHolidaysForRestNextYear(data.providerId, data.dateNow).then((success: any) => {        
        return Promise.resolve(success.data);
      }, error => {
        return Promise.reject(error);
      })
    },
    createParentReoccurringOrders({ commit }: any, bookedOrder: BookedOrder) {
      return BookingService.createParentReoccurringOrders(bookedOrder).then((success: any) => {
        return Promise.resolve(success.data);
      }, (error: any) => {
        return Promise.reject(error);
      })
    },
    createChildcareReoccurringOrders({ commit }: any, bookedOrder: BookedOrder) {
      return BookingService.createChildcareReoccurringOrders(bookedOrder).then((success: any) => {
        return Promise.resolve(success.data);
      }, (error: any) => {
        return Promise.reject(error);
      })
    },
    getProviderBackgroundGallery({ commit }: any, userId: string) {
      return BookingService.getProviderBackgroundGallery(userId).then(success => {
        commit('saveProviderBackgroundGallery', success.data);
        commit('updateProviderBackgroundGalleryIsDispatched', new ProviderBackgroundGalleryIsDispatchedModel(userId, true));
        return Promise.resolve(success.data);
       }, error => {
        return Promise.reject(error);
       })
    },
    saveProviderBackgroundGallery({ commit }: any, data: any) {            
      return BookingService.saveProviderBackgroundGallery(data).then(success => {
        commit('saveProviderBackgroundGallery', success.data);
        return Promise.resolve(success);
       }, error => {
        return Promise.reject(error);
       })
    },
    getBookingStatus({ commit }: any) {            
      return BookingService.getBookingStatus().then(success => {
        commit('updateBookingStatus', success.data);
        return Promise.resolve(success.data);
       }, error => {
        return Promise.reject(error);
       })
    },
    updateBookingStatus({ commit }: any, bookingStatus: BookingStatus) {      
      return BookingService.updateBookingStatus(bookingStatus).then((success: any) => {
        commit('updateBookingStatus', success.data);
        return Promise.resolve(success.data);
      }, (error: any) => {
        return Promise.reject(error);
      })
    },
  },
  mutations: {
    clear(state: any) {
      state.namespaced = true;
      state.childcareProviders = [];
      state.childIdForBooking = '';
      state.providerIdForBooking = '';
      state.bookingStatus = new BookingStatus();
      state.providerBackgroundGalleryIsDispatched = new Array<ProviderBackgroundGalleryIsDispatchedModel>();
      state.providerBackgroundGallery = new Array<ProviderBackgroundGalleryModel>();
  
      //Booking time page
      state.bookedDays = new Array<BookedOrder>();
      state.workingSchedule = [];
    },
    setChildId(state: any, id: string) {
      state.childId = id;
    },
    setProviders(state: any, childcareProviders: []) {
      state.childcareProviders = [...childcareProviders];
    },
    setBookingChildId(state: any, childId: string) {
      state.childIdForBooking = childId;
    },
    setBookingProviderId(state: any, providerId: string) {
      state.providerIdForBooking = providerId;
    },
    //Booking time page
    //Добавление дня после успешной отправки на сервер
    addBookedDay(state: any, newDay: BookedOrder) {
      state.bookedDays.unshift(newDay)
    },
    removeBookedDay(state: any, id: "string") {
      const index = state.bookedDays.findIndex((day: BookedOrder) => day.id === id)

      state.bookedDays.splice(index, 1);
    },
    setBookedDays(state: any, payload: any) {      
      state.bookedDays = payload;
    },
    updateBookedDay(state: any, data: BookedOrder) {
      const foundIndex = state.bookedDays.findIndex((x: BookedOrder) => x.id == data.id);

      if (foundIndex > -1) {
        state.bookedDays.splice(foundIndex, 1, data);
      }
    },
    setWorkingSchedule(state: any, workingSchedule: []) {
      state.workingSchedule = workingSchedule;
    },
    setSelectedChildId(state: any, newDay: BookedOrder) {
      state.bookedDays.unshift(newDay);
    },
    updateBookingStatus(state: any, bookingStatus: BookingStatus) {
      state.bookingStatus = bookingStatus;
    },
    saveProviderBackgroundGallery(state: any, providerBackgroundGallery: ProviderBackgroundGalleryModel) {
      const foundIndex: number = state
        .providerBackgroundGallery
        .findIndex((item: ProviderBackgroundGalleryModel) => item.userId == providerBackgroundGallery.userId);

      if (foundIndex > -1) {
        state.providerBackgroundGallery.splice(foundIndex, 1, providerBackgroundGallery);
      }
      else {
        state.providerBackgroundGallery.push(providerBackgroundGallery);
      }      
    },
    updateProviderBackgroundGalleryIsDispatched(state: any, providerBackgroundGalleryIsDispatched: ProviderBackgroundGalleryIsDispatchedModel) {
      const foundIndex: number = state
        .providerBackgroundGalleryIsDispatched
        .findIndex((item: ProviderBackgroundGalleryIsDispatchedModel) => item.userId == providerBackgroundGalleryIsDispatched.userId);

      if (foundIndex > -1) {
        state.providerBackgroundGalleryIsDispatched.splice(foundIndex, 1, providerBackgroundGalleryIsDispatched);
      }
      else {
        state.providerBackgroundGalleryIsDispatched.push(providerBackgroundGalleryIsDispatched);
      }
    },
  }
};

export default booking;